<form
  class="relative flex h-full flex-col gap-8 py-5"
  [formGroup]="form"
  (ngSubmit)="saveSleepHours()"
  #myForm="ngForm"
>
  <pl-icon
    [frame]="IconFrame.round"
    [name]="PlIcon.close"
    (click)="closeModal()"
    class="absolute right-2 top-2 z-10 h-12 w-12 cursor-pointer border-transparent bg-transparent text-pl-gray-700 hover:bg-pl-gray-200"
  />
  <div class="flex grow flex-col gap-4 overflow-auto px-5">
    <h2 class="mb-4 font-sans text-pl-gray-500">
      {{ 'lifemap.sleep_hours_modal.title' | translate }}
    </h2>

    <p class="pl-inner-html text-lg" [innerHTML]="'lifemap.sleep_hours_modal.body_1' | translate"></p>
    <p class="pl-inner-html text-lg italic" [innerHTML]="'lifemap.sleep_hours_modal.body_2' | translate"></p>

    <div class="flex flex-col gap-8">
      <pl-timepicker
        [formControlName]="FormControlName.sleepAt"
        [isFormSubmitted]="myForm.submitted"
        [label]="'lifemap.sleep_hours_modal.label_sleep' | translate"
        [minutesGap]="30"
        [icon]="PlIcon.moon"
        [format]="timeFormat()"
      ></pl-timepicker>
      <pl-timepicker
        [formControlName]="FormControlName.wakeUpAt"
        [isFormSubmitted]="myForm.submitted"
        [label]="'lifemap.sleep_hours_modal.label_wake_up' | translate"
        [minutesGap]="30"
        [icon]="PlIcon.sun"
        [format]="timeFormat()"
      ></pl-timepicker>
    </div>
    <p
      *ngIf="myForm.submitted && form.errors && form.errors[CustomErrors.durationTooLong]"
      class="text-sm text-pl-error"
    >
      {{
        'lifemap.select_duration_less_than_12_hours'
          | translate: { numberHours: form.errors[CustomErrors.durationTooLong] }
      }}
    </p>
  </div>

  <div class="flex justify-end gap-4 px-5">
    <pl-button class="" [variant]="ButtonVariant.white" (click)="closeModal()">
      {{ 'utils.skip' | translate }}
    </pl-button>
    <pl-button [variant]="ButtonVariant.orange" [type]="PlButtonType.submit">
      {{ 'utils.save' | translate }}
    </pl-button>
  </div>
</form>
